import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { getProjectUrl } from '../../utils/slugify';

const ProjectCard = ({ project, index, size = "standard" }) => {
    const large = size === "large";
    return (
        <article
            className="group relative rounded-3xl overflow-hidden bg-white border border-designer-dark/10 transition-shadow duration-300 hover:shadow-[0_24px_60px_-24px_rgba(29,32,48,0.3)] h-full"
            itemScope
            itemType="https://schema.org/CreativeWork"
        >
            <Link
                to={getProjectUrl(project.slug)}
                aria-label={`View details for ${project.title} project`}
                className="flex flex-col h-full rounded-3xl focus:outline-none focus-visible:ring-2 focus-visible:ring-designer-primary focus-visible:ring-inset"
            >
                <div className="relative overflow-hidden flex-shrink-0">
                    <img
                        src={project.image}
                        alt={`${project.title} - ${project.category} project by Arvix Creative`}
                        loading="lazy"
                        decoding="async"
                        className={`w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] ${large ? "h-72 md:h-[26rem]" : "h-60 md:h-64"}`}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-designer-dark/50 via-transparent to-transparent opacity-70 pointer-events-none"></div>
                    <span
                        className="absolute top-4 left-4 inline-flex items-center px-3 py-1 rounded-full text-[11px] font-bold tracking-[0.14em] uppercase bg-white/90 backdrop-blur text-designer-dark"
                        itemProp="genre"
                    >
                        {project.category}
                    </span>
                    <span className="absolute bottom-4 right-4 font-mono text-xs text-white/70" aria-hidden="true">
                        {String((index ?? 0) + 1).padStart(2, "0")}
                    </span>
                </div>
                <div className={`flex flex-col flex-grow ${large ? "p-6 md:p-8" : "p-6"}`}>
                    <h3
                        className={`font-display font-bold text-designer-dark tracking-tight leading-snug ${large ? "text-2xl md:text-[1.7rem]" : "text-xl line-clamp-2"}`}
                        itemProp="name"
                    >
                        {project.title}
                    </h3>
                    <p
                        className="text-gray-600 mt-2 line-clamp-2 flex-grow text-[15px] leading-relaxed"
                        itemProp="description"
                    >
                        {project.description}
                    </p>
                    <span className="mt-5 inline-flex items-center gap-2 font-semibold text-sm text-designer-dark group-hover:text-designer-primary transition-colors w-fit">
                        <span className="link-sweep">View case study</span>
                        <FaArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
                    </span>
                </div>
            </Link>
        </article>
    );
};

export default ProjectCard;
